module.exports = __webpack_public_path__ + "img/button_linkcard.19dba88.svg";